import { FilterFilled, FilterOutlined } from '@ant-design/icons';
import { useLazyQuery, useMutation } from '@apollo/client';
import {
  Badge,
  Button,
  Checkbox,
  DatePicker,
  Divider,
  Empty,
  Image,
  Modal,
  Radio,
  Tag,
  Tooltip,
} from 'antd';
import { debounce, filter, forEach, isEmpty, map } from 'lodash';
import { useContext, useEffect, useMemo, useRef, useState } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import { AppContext } from '../../../../../AppContext';
import { ReactComponent as CommentIcon } from '../../../../../assets/svg/comment-dots-solid.svg';
import { ReactComponent as InfoIcon } from '../../../../../assets/svg/info-solid.svg';
import { ReactComponent as PlayIcon } from '../../../../../assets/svg/play-solid.svg';
import { ReactComponent as TruckIcon } from '../../../../../assets/svg/purple_truck.svg';
import { ReactComponent as FilterIcon } from '../../../../../assets/svg/sliders-solid.svg';
import { ReactComponent as DislikeRatingIcon } from '../../../../../assets/svg/thumbs-down-solid.svg';
import { ReactComponent as LikeRatingIcon } from '../../../../../assets/svg/thumbs-up-solid.svg';
import ORDER_TAG_BULK_ACTIONS, {
  DATE_FORMATS,
  DELIVERY_TYPE,
  DELIVERY_TYPE_OPTIONS,
  LIMIT,
  ORDER_TAG_TYPES,
  PERMISSIONS_KEY,
  PERMISSION_TYPE,
  PRODUCT_RATE,
  RETURN_ORDER_ITEM_STATUS,
  ROUTES,
  SORT,
  TABLE_FILTER_KEYS,
  USER_ROLES,
} from '../../../../../common/constants';
import {
  formatDate,
  getAttachmentSource,
  handleOpenUserDrawer,
  hasLargeToy,
  hasNonEmptyValueObj,
  hasPermission,
  isSalesUser,
  toDayjsRange,
} from '../../../../../common/utils';
import BulkActionButton from '../../../../../components/BulkActionButton';
import CommonPreview from '../../../../../components/CommonPreview';
import CommonPreviewTable from '../../../../../components/CommonPreviewTable';
import CommonTable from '../../../../../components/CommonTable';
import FulfilmentPossibilityDrawer from '../../../../../components/FulfilmentPossibilityDrawer';
import LoaderComponent from '../../../../../components/LoaderComponent';
import MappedUnitsCell from '../../../../../components/MappedUnitsCell';
import ModalComponent from '../../../../../components/ModalComponent';
import OrderDynamicTags from '../../../../../components/OrderDynamicTags';
import OrderTagsFilter from '../../../../../components/OrderTagsFilter';
import RenderCopyIcon from '../../../../../components/RenderCopyIcon';
import SkipChecklistAction, {
  getSkipChecklistValue,
} from '../../../../../components/ReturnOrders/SkipChecklistAction';
import SearchComponent from '../../../../../components/SearchComponent';
import TrackOrderIframeModal from '../../../../../components/TrackOrderIframeModal';
import { PINCODES } from '../../../../../components/graphql/Queries';
import useInfiniteScroll from '../../../../../hooks/useInfiniteScroll';
import useRetainedTableState from '../../../../../hooks/useRetainedTableFilterState';
import useToyDrawer from '../../../../../hooks/useToyDrawer';
import AllFilterReturnOrderModal from '../../../../../libraryModules/orders/modules/all/components/AllFilterReturnOrderModal';
import AllReturnOrderItemModal from '../../../../../libraryModules/orders/modules/all/components/AllReturnOrderItemModal';
import AllReturnOrderList from '../../../../../libraryModules/orders/modules/all/components/AllReturnOrderList';
import ToyVideoModal from '../../../../../libraryModules/raiseRequest/components/ToyVideoModal';
import { USERS } from '../../../../../libraryModules/raiseRequest/graphql/Queries';
import { LIBRARIES } from '../../../../lists/modules/library/graphql/Queries';
import BigToyIcon from '../../new/components/BigToyIcon';
import StatusFlag from '../../new/components/OrderTagRenderer';
import { CANCEL_RETURN_ORDER_REQUEST_ADMIN } from '../graphql/Mutations';
import {
  RETURN_ORDERS_ADMIN,
  RETURN_ORDERS_ADMIN_SELECT,
  TOYS,
} from '../graphql/Queries';
import ContentMasterModal from './ContentMasterModal';
import ReturnItemStatusModal from './ReturnItemStatusModal';

const { RangePicker } = DatePicker;
const { Group } = Radio;

const initialPaginationValue = {
  total: 0,
  current: 1,
  pageSize: 10,
};

const initialOrderFilter = {
  limit: LIMIT,
  search: '',
  skip: 0,
};

const initialOrderSort = {
  field: 'createdAt',
  order: 'DESC',
};

const initialTableFilter = {
  skip: 0,
  limit: LIMIT,
  search: '',
};

const initialTableSort = {
  field: 'createdAt',
  order: 'DESC',
};

let filterScrollDebounceJob = null;

const AllReturnTable = ({ exportFilter, setExportFilter }) => {
  const {
    dispatch,
    state: {
      isDesktop,
      permissions,
      currentUser,
      commonPermissions: {
        isUserPermission,
        isDeliveryPartnerPermission,
        isToyPermission,
        isLibraryPermission,
      },
    },
  } = useContext(AppContext);
  const history = useHistory();
  const { openToyDrawer } = useToyDrawer();
  const location = useLocation();
  const queryParams = new URLSearchParams(location?.search);
  const user = queryParams?.get('user') || '';
  const [orderList, setOrderList] = useState([]);
  const [possibilityDrawerVisible, setPossibilityDrawerVisible] = useState(
    false,
  );
  const [selectedPossibilityItem, setSelectedPossibilityItem] = useState(null);
  const [selectedReturnOrders, setSelectedReturnOrders] = useState([]);
  const [orderSearchTerm, setOrderSearchTerm] = useState('');
  const [isEmptyOrderList, setIsEmptyOrderList] = useState(false);
  const [query, setQuery] = useState('');
  const [sortedInfo, setSortedInfo] = useState({});
  const [paginationProp, setPaginationProp] = useState(initialPaginationValue);

  const [order, setOrder] = useState({});
  const [isOrderLoading, setIsOrderLoading] = useState(true);
  const [isRequestPrompts, setIsRequestPrompts] = useState(false);
  const [isRequestLoadings, setIsRequestLoadings] = useState(false);
  const [orderItem, setOrderItem] = useState({});

  const [visible, setVisible] = useState(false);
  const [toyImages, setToyImages] = useState([]);
  const [previewVisible, setPreviewVisible] = useState(false);
  const [toyPreviewImage, setToyPreviewImage] = useState();
  const [isVideoModalOpen, setIsVideoModalOpen] = useState(false);

  const [filterSearch, setFilterSearch] = useState('');
  const [filterList, setFilterList] = useState([]);
  const [whereFilter, setWhereFilter] = useState();
  const [filterLoading, setFilterLoading] = useState(false);
  const [filterTags, setFilterTags] = useState(null);
  const [filterVisible, setFilterVisible] = useState(false);
  const [filterIndex, setFilterIndex] = useState(null);
  const [finalWhereFilters, setFinalWhereFilters] = useState();
  const [finalFilterTags, setFinalFilterTags] = useState(null);
  const [selectedTagIds, setSelectedTagIds] = useState([]);
  const selectedTagIdsRef = useRef([]);
  const [filterIsEnd, setFilterIsEnd] = useState(false);
  const [isEmptyFilterList, setIsEmptyFilterList] = useState(false);
  const [isOrderStatusModalOpen, setIsOrderStatusModalOpen] = useState(false);
  const [isContentMasterModalOpen, setIsContentMasterModalOpen] = useState(
    false,
  );
  const [isAllFilterModalOpen, setIsAllFilterModalOpen] = useState(false);
  const [isFetchMoreOrderLoading, setIsFetchMoreOrderLoading] = useState(false);
  const [isActive, setIsActive] = useState(true);
  const [
    isAllReturnOrderItemModalOpen,
    setIsAllReturnOrderItemModalOpen,
  ] = useState(false);
  const [isTrackingModalOpen, setIsTrackingModalOpen] = useState(false);
  const [trackingUrl, setTrackingUrl] = useState('');
  const [
    isNotPickedUpReasonModalOpen,
    setIsNotPickedUpReasonModalOpen,
  ] = useState(false);
  const [notPickedUpReason, setNotPickedUpReason] = useState('');
  const [notPickedUpRiderName, setNotPickedUpRiderName] = useState('');

  const {
    hydrated,
    retainedState,
    saveRetainedFilterState,
  } = useRetainedTableState();
  const finalWhereFiltersRef = useRef(null);
  const sortedInfoRef = useRef(null);
  const paginationPropRef = useRef(null);
  const orderSearchTermRef = useRef(null);

  const [initializedFromRetained, setInitializedFromRetained] = useState(false);

  useEffect(() => {
    if (!hydrated) return;
    if (initializedFromRetained) return;

    const retaineFiters = retainedState?.[TABLE_FILTER_KEYS.ALL_RETURN];
    if (!retaineFiters) {
      setInitializedFromRetained(true);
      return;
    }
    setFilterTags(retaineFiters?.filterTags || {});
    setFinalFilterTags(retaineFiters?.filterTags || {});
    const baseFilters = retaineFiters?.filters || {};
    const normalizedFilters = {
      ...baseFilters,
      createdAt: toDayjsRange(baseFilters?.createdAt),
      returnedOn: toDayjsRange(baseFilters?.returnedOn),
    };
    setFinalWhereFilters(normalizedFilters);
    finalWhereFiltersRef.current = normalizedFilters;

    setSortedInfo(retaineFiters?.sort);
    sortedInfoRef.current = retaineFiters?.sort;

    setPaginationProp(retaineFiters?.paginationProp);
    paginationPropRef.current = retaineFiters?.paginationProp;

    setOrderSearchTerm(retaineFiters?.searchTerm);
    setQuery(retaineFiters?.searchTerm);
    orderSearchTermRef.current = retaineFiters?.searchTerm;

    setInitializedFromRetained(true);
  }, [hydrated, initializedFromRetained, retainedState]);

  const hasUpdatePermission = hasPermission(
    PERMISSIONS_KEY?.ORDERS_ALL_RETURN,
    PERMISSION_TYPE?.UPDATE,
    permissions,
  );

  const [returnOrdersAdmin] = useLazyQuery(RETURN_ORDERS_ADMIN, {
    onCompleted: (response) => {
      if (isDesktop) {
        setOrderList([...response?.returnOrdersAdmin?.data]);
      } else {
        setOrderList([...orderList, ...response?.returnOrdersAdmin?.data]);
      }
      if (
        response?.returnOrdersAdmin?.count === 0 &&
        initialPaginationValue?.total === 0
      ) {
        setIsEmptyOrderList(true);
      } else {
        setIsEmptyOrderList(false);
      }

      if (response?.returnOrdersAdmin?.data?.length < LIMIT) {
        setIsActive(false);
      }

      const pagination = {
        ...paginationProp,
        defaultPageSize: LIMIT,
        total: response?.returnOrdersAdmin?.count,
      };
      setPaginationProp(pagination);
      saveRetainedFilterState(TABLE_FILTER_KEYS.ALL_RETURN, {
        paginationProp: pagination,
      });
      setIsOrderLoading(false);
      setIsFetchMoreOrderLoading(false);
    },
    fetchPolicy: 'no-cache',
    onError() {},
  });

  const [pincodes, { loading: isPincodesLoading }] = useLazyQuery(PINCODES, {
    onCompleted: (response) => {
      if (response?.pincodes?.data?.length < LIMIT) {
        setFilterIsEnd(true);
      }
      if (response?.pincodes?.count === 0) {
        setIsEmptyFilterList(true);
      } else {
        setIsEmptyFilterList(false);
      }
      const optionsCopy = [];
      forEach(response?.pincodes?.data, (item) =>
        optionsCopy?.push({
          label: item?.pincode,
          key: item?.id,
        }),
      );
      setFilterList([...filterList, ...optionsCopy]);
      setFilterLoading(false);
    },
    fetchPolicy: 'network-only',
    onError() {
      setFilterLoading(false);
    },
  });

  const [users, { loading: isUsersLoading }] = useLazyQuery(USERS, {
    onCompleted: (response) => {
      if (response?.users?.data?.length < LIMIT) {
        setFilterIsEnd(true);
      }
      if (response?.users?.count === 0) {
        setIsEmptyFilterList(true);
      } else {
        setIsEmptyFilterList(false);
      }
      const optionsCopy = [];
      forEach(response?.users?.data, (item) =>
        optionsCopy?.push({
          label: `${
            item?.firstName || item?.lastName
              ? `${item?.firstName || ''} ${item?.lastName || ''}`
              : '-'
          }`,
          key: item?.id,
        }),
      );
      setFilterList([...filterList, ...optionsCopy]);
      setFilterLoading(false);
    },
    fetchPolicy: 'network-only',
    onError() {
      setFilterLoading(false);
    },
  });

  const [
    returnOrdersAdminSelect,
    { loading: isReturnOrdersAdminSelectLoading },
  ] = useLazyQuery(RETURN_ORDERS_ADMIN_SELECT, {
    onCompleted: (response) => {
      if (response?.returnOrdersAdmin?.data?.length < LIMIT) {
        setFilterIsEnd(true);
      }
      if (response?.returnOrdersAdmin?.count === 0) {
        setIsEmptyFilterList(true);
      } else {
        setIsEmptyFilterList(false);
      }
      const optionsCopy = [];
      forEach(response?.returnOrdersAdmin?.data, (item) =>
        optionsCopy?.push({
          label: item?.returnOrder?.returnOrderNumber,
          key: item?.returnOrder?.id,
        }),
      );
      setFilterList([...filterList, ...optionsCopy]);
      setFilterLoading(false);
    },
    fetchPolicy: 'network-only',
    onError() {
      setFilterLoading(false);
    },
  });

  const [toys, { loading: isToysLoading }] = useLazyQuery(TOYS, {
    onCompleted: (response) => {
      if (response?.toys?.data?.length < LIMIT) {
        setFilterIsEnd(true);
      }
      if (response?.toys?.count === 0) {
        setIsEmptyFilterList(true);
      } else {
        setIsEmptyFilterList(false);
      }
      const optionsCopy = [];
      forEach(response?.toys?.data, (item) =>
        optionsCopy?.push({
          label: item?.name,
          key: item?.id,
        }),
      );
      setFilterList([...filterList, ...optionsCopy]);
      setFilterLoading(false);
    },
    fetchPolicy: 'network-only',
    onError() {
      setFilterLoading(false);
    },
  });

  const [libraries, { loading: isLibrariesLoading }] = useLazyQuery(LIBRARIES, {
    onCompleted: (response) => {
      if (response?.libraries?.data?.length < LIMIT) {
        setFilterIsEnd(true);
      }
      if (response?.libraries?.count === 0) {
        setIsEmptyFilterList(true);
      } else {
        setIsEmptyFilterList(false);
      }
      const optionsCopy = [];
      forEach(response?.libraries?.data, (item) =>
        optionsCopy?.push({ label: item?.name, key: item?.id }),
      );
      setFilterList([...filterList, ...optionsCopy]);
      setFilterLoading(false);
    },
    fetchPolicy: 'network-only',
    onError() {
      setFilterLoading(false);
    },
  });

  const [
    receivingLibraries,
    { loading: isReceivingLibrariesLoading },
  ] = useLazyQuery(LIBRARIES, {
    onCompleted: (response) => {
      if (response?.libraries?.data?.length < LIMIT) {
        setFilterIsEnd(true);
      }
      if (response?.libraries?.count === 0) {
        setIsEmptyFilterList(true);
      } else {
        setIsEmptyFilterList(false);
      }
      const optionsCopy = [];
      forEach(response?.libraries?.data, (item) =>
        optionsCopy?.push({ label: item?.name, key: item?.id }),
      );
      setFilterList([...filterList, ...optionsCopy]);
      setFilterLoading(false);
    },
    fetchPolicy: 'network-only',
    onError() {
      setFilterLoading(false);
    },
  });

  const [cancelReturnOrderRequestAdmin] = useMutation(
    CANCEL_RETURN_ORDER_REQUEST_ADMIN,
    {
      onError: () => {},
    },
  );

  useEffect(() => {
    if (!hydrated || !initializedFromRetained) return; // NEW

    if (user) {
      setQuery(user);
      setOrderSearchTerm(user);
    }
    setPaginationProp({
      ...paginationProp,
      current: paginationPropRef?.current?.current,
      skip:
        (paginationPropRef?.current?.current - 1) *
        (paginationPropRef?.current?.pageSize || 0),
    });

    saveRetainedFilterState(TABLE_FILTER_KEYS.ALL_RETURN, {
      paginationProp: {
        ...paginationProp,
        current: paginationPropRef?.current?.current,
        skip:
          (paginationPropRef?.current?.current - 1) *
          (paginationPropRef?.current?.pageSize || 0),
      },
    });
    setIsOrderLoading(true);
    returnOrdersAdmin({
      variables: {
        filter: {
          ...initialOrderFilter,
          search: user || orderSearchTermRef?.current,
          limit: paginationPropRef?.current?.pageSize || LIMIT,
          skip:
            (paginationPropRef?.current?.current - 1) *
            (paginationPropRef?.current?.pageSize || 0),
          deliveryType: finalWhereFiltersRef?.current?.deliveryType,
          dateRange: {
            from: finalWhereFiltersRef?.current?.createdAt?.from?.$d,
            to: finalWhereFiltersRef?.current?.createdAt?.to?.$d,
          },
          returnedOn: {
            from: finalWhereFiltersRef?.current?.returnedOn?.from?.$d,
            to: finalWhereFiltersRef?.current?.returnedOn?.to?.$d,
          },
          status:
            finalWhereFiltersRef?.current?.status?.length > 0
              ? finalWhereFiltersRef?.current?.status
              : initialOrderFilter?.status,
          pincodeIds: finalWhereFiltersRef?.current?.pincodes,
          deliveryPartnerIds:
            finalWhereFiltersRef?.current?.deliveryPartnerName,
          returnOrderIds: finalWhereFiltersRef?.current?.returnOrderNumber,
          toyIds: finalWhereFiltersRef?.current?.productName,
          libraryIds: finalWhereFiltersRef?.current?.name,
          receivingLibraryIds: finalWhereFiltersRef?.current?.receivingLibName,
          orderTagIds:
            selectedTagIdsRef?.current?.length > 0
              ? selectedTagIdsRef.current
              : undefined,
        },
        sort: initialOrderSort,
      },
    });
  }, [hydrated, initializedFromRetained]);

  const handleTableChange = (pagination, tableFilter, sorter) => {
    const { current } = pagination;
    const skip = (current - 1) * (pagination?.pageSize || 0);
    setPaginationProp({ ...paginationProp, ...pagination });
    setIsOrderLoading(true);
    setSortedInfo(sorter);
    saveRetainedFilterState(TABLE_FILTER_KEYS.ALL_RETURN, {
      sort: sorter,
      paginationProp: { ...paginationProp, ...pagination },
    });

    returnOrdersAdmin({
      variables: {
        filter: {
          ...initialOrderFilter,
          skip,
          limit: pagination?.pageSize,
          search: orderSearchTerm,
          deliveryType: finalWhereFilters?.deliveryType,
          dateRange: {
            from: finalWhereFilters?.createdAt?.from?.$d,
            to: finalWhereFilters?.createdAt?.to?.$d,
          },
          returnedOn: {
            from: finalWhereFilters?.returnedOn?.from?.$d,
            to: finalWhereFilters?.returnedOn?.to?.$d,
          },
          status:
            finalWhereFilters?.status?.length > 0
              ? finalWhereFilters?.status
              : undefined,
          pincodeIds: finalWhereFilters?.pincodes,
          deliveryPartnerIds: finalWhereFilters?.deliveryPartnerName,
          returnOrderIds: finalWhereFilters?.returnOrderNumber,
          toyIds: finalWhereFilters?.productName,
          libraryIds: finalWhereFilters?.name,
          receivingLibraryIds: finalWhereFilters?.receivingLibName,
          orderTagIds:
            selectedTagIdsRef?.current?.length > 0
              ? selectedTagIdsRef.current
              : undefined,
        },
        sort: sorter?.column
          ? {
              field: sorter?.field,
              order: sorter?.order === 'ascend' ? SORT?.ASC : SORT?.DESC,
            }
          : initialOrderSort,
      },
    });
  };

  const handleSearch = (value) => {
    const trimValue = value?.trim();
    setOrderSearchTerm(trimValue);
    setPaginationProp({ ...paginationProp, current: 1, skip: 0 });
    saveRetainedFilterState(TABLE_FILTER_KEYS.ALL_RETURN, {
      searchTerm: trimValue,
      paginationProp: { ...paginationProp, current: 1, skip: 0 },
    });

    setIsOrderLoading(true);
    setOrderList([]);
    returnOrdersAdmin({
      variables: {
        filter: {
          ...initialOrderFilter,
          limit: paginationProp?.pageSize || LIMIT,
          search: trimValue,
          deliveryType: finalWhereFilters?.deliveryType,
          dateRange: {
            from: finalWhereFilters?.createdAt?.from?.$d,
            to: finalWhereFilters?.createdAt?.to?.$d,
          },
          returnedOn: {
            from: finalWhereFilters?.returnedOn?.from?.$d,
            to: finalWhereFilters?.returnedOn?.to?.$d,
          },
          status:
            finalWhereFilters?.status?.length > 0
              ? finalWhereFilters?.status
              : undefined,
          pincodeIds: finalWhereFilters?.pincodes,
          deliveryPartnerIds: finalWhereFilters?.deliveryPartnerName,
          returnOrderIds: finalWhereFilters?.returnOrderNumber,
          toyIds: finalWhereFilters?.productName,
          libraryIds: finalWhereFilters?.name,
          receivingLibraryIds: finalWhereFilters?.receivingLibName,
          orderTagIds:
            selectedTagIdsRef?.current?.length > 0
              ? selectedTagIdsRef.current
              : undefined,
        },
        sort: sortedInfo?.column
          ? {
              field: sortedInfo?.field,
              order: sortedInfo?.order === 'ascend' ? SORT?.ASC : SORT?.DESC,
            }
          : initialOrderSort,
      },
    });
    setExportFilter({ ...exportFilter, search: trimValue });
  };

  const handleTagFilterChange = (tagIds) => {
    selectedTagIdsRef.current = tagIds;
    setSelectedTagIds(tagIds);
    setIsOrderLoading(true);
    setOrderList([]);
    setIsActive(true);
    setPaginationProp({ ...paginationProp, current: 1, skip: 0 });
    paginationPropRef.current = {
      ...paginationPropRef.current,
      current: 1,
      skip: 0,
    };
    returnOrdersAdmin({
      variables: {
        filter: {
          ...initialOrderFilter,
          limit: paginationProp?.pageSize || LIMIT,
          search: orderSearchTermRef?.current,
          deliveryType: finalWhereFiltersRef?.current?.deliveryType,
          dateRange: {
            from: finalWhereFiltersRef?.current?.createdAt?.from?.$d,
            to: finalWhereFiltersRef?.current?.createdAt?.to?.$d,
          },
          returnedOn: {
            from: finalWhereFiltersRef?.current?.returnedOn?.from?.$d,
            to: finalWhereFiltersRef?.current?.returnedOn?.to?.$d,
          },
          status:
            finalWhereFiltersRef?.current?.status?.length > 0
              ? finalWhereFiltersRef?.current?.status
              : initialOrderFilter?.status,
          pincodeIds: finalWhereFiltersRef?.current?.pincodes,
          deliveryPartnerIds:
            finalWhereFiltersRef?.current?.deliveryPartnerName,
          returnOrderIds: finalWhereFiltersRef?.current?.returnOrderNumber,
          toyIds: finalWhereFiltersRef?.current?.productName,
          libraryIds: finalWhereFiltersRef?.current?.name,
          receivingLibraryIds: finalWhereFiltersRef?.current?.receivingLibName,
          orderTagIds: tagIds?.length > 0 ? tagIds : undefined,
        },
        sort: sortedInfoRef?.current?.column
          ? {
              field: sortedInfoRef?.current?.field,
              order:
                sortedInfoRef?.current?.order === 'ascend'
                  ? SORT?.ASC
                  : SORT?.DESC,
            }
          : initialOrderSort,
      },
    });
  };

  const handleOrderScroll = () => {
    if (!isFetchMoreOrderLoading && !isOrderLoading) {
      const currentLength = orderList?.length;
      setIsFetchMoreOrderLoading(true);
      returnOrdersAdmin({
        variables: {
          filter: {
            ...initialOrderFilter,
            skip: currentLength,
            limit: paginationProp?.pageSize || LIMIT,
            search: orderSearchTerm,
            deliveryType: finalWhereFilters?.deliveryType,
            dateRange: {
              from: finalWhereFilters?.createdAt?.from?.$d,
              to: finalWhereFilters?.createdAt?.to?.$d,
            },
            returnedOn: {
              from: finalWhereFilters?.returnedOn?.from?.$d,
              to: finalWhereFilters?.returnedOn?.to?.$d,
            },
            status:
              finalWhereFilters?.status?.length > 0
                ? finalWhereFilters?.status
                : initialOrderFilter?.status,
            returnOrderIds: finalWhereFilters?.returnOrderNumber,
            pincodeIds: finalWhereFilters?.pincodes,
            ownerLibraryIds:
              finalWhereFilters?.ownerLibraryName?.length > 0
                ? finalWhereFilters?.ownerLibraryName
                : undefined,
            receivingLibraryIds:
              finalWhereFilters?.receivingLibraryName?.length > 0
                ? finalWhereFilters?.receivingLibraryName
                : undefined,
            orderTagIds:
              selectedTagIdsRef?.current?.length > 0
                ? selectedTagIdsRef.current
                : undefined,
          },
          sort: sortedInfo?.column
            ? {
                field: sortedInfo?.field,
                order: sortedInfo?.order === 'ascend' ? SORT?.ASC : SORT?.DESC,
              }
            : initialOrderSort,
        },
      });
    }
  };

  const handleFilter = (values) => {
    setPaginationProp({ ...paginationProp, current: 1, skip: 0 });
    setIsOrderLoading(true);
    setIsAllFilterModalOpen(false);
    setOrderList([]);
    setIsActive(true);
    const filters = {
      status: values?.status,
      createdAt: values?.createdAt?.[1]
        ? { from: values?.createdAt?.[0], to: values?.createdAt?.[1] }
        : null,
      returnedOn: values?.returnedOn?.[1]
        ? { from: values?.returnedOn?.[0], to: values?.returnedOn?.[1] }
        : null,
      pincodes: values?.pincodes,
      deliveryType: values?.deliveryType,
      ownerLibraryName: values?.ownerLibraryName,
      receivingLibraryName: values?.receivingLibraryName,
    };
    setWhereFilter(filters);
    setFinalWhereFilters(filters);
    saveRetainedFilterState(TABLE_FILTER_KEYS.ALL_RETURN, {
      filters,
      paginationProp: { ...paginationProp, current: 1, skip: 0 },
    });
    returnOrdersAdmin({
      variables: {
        filter: {
          ...initialOrderFilter,
          limit: paginationProp?.pageSize || LIMIT,
          search: orderSearchTerm,
          deliveryType: values?.deliveryType,
          dateRange: {
            from: values?.createdAt?.[0],
            to: values?.createdAt?.[1],
          },
          returnedOn: {
            from: values?.returnedOn?.[0],
            to: values?.returnedOn?.[1],
          },
          status:
            values?.status?.length > 0
              ? values?.status
              : initialOrderFilter?.status,
          pincodeIds: values?.pincodes,
          ownerLibraryIds:
            values?.ownerLibraryName?.length > 0
              ? values?.ownerLibraryName
              : undefined,
          receivingLibraryIds:
            values?.receivingLibraryName?.length > 0
              ? values?.receivingLibraryName
              : undefined,
          orderTagIds:
            selectedTagIdsRef?.current?.length > 0
              ? selectedTagIdsRef.current
              : undefined,
        },
        sort: sortedInfo?.column
          ? {
              field: sortedInfo?.field,
              order: sortedInfo?.order === 'ascend' ? SORT?.ASC : SORT?.DESC,
            }
          : initialOrderSort,
      },
    });
  };

  const infiniteScrollRef = useInfiniteScroll(handleOrderScroll, isActive);

  const handleReturnRequest = async () => {
    setIsRequestLoadings(true);
    const response = await cancelReturnOrderRequestAdmin({
      variables: {
        where: {
          id: order?.id,
        },
      },
    });
    if (response?.data) {
      setIsOrderLoading(true);
      setIsRequestPrompts(false);
      setOrderList([]);
      returnOrdersAdmin({
        variables: {
          filter: {
            ...initialOrderFilter,
            limit: paginationProp?.pageSize || LIMIT,
            search: orderSearchTerm,
            deliveryType: finalWhereFilters?.deliveryType,
            dateRange: {
              from: finalWhereFilters?.createdAt?.from?.$d,
              to: finalWhereFilters?.createdAt?.to?.$d,
            },
            returnedOn: {
              from: finalWhereFilters?.returnedOn?.from?.$d,
              to: finalWhereFilters?.returnedOn?.to?.$d,
            },
            status:
              finalWhereFilters?.status?.length > 0
                ? finalWhereFilters?.status
                : undefined,
            pincodeIds: finalWhereFilters?.pincodes,
            deliveryPartnerIds: finalWhereFilters?.deliveryPartnerName,
            returnOrderIds: finalWhereFilters?.returnOrderNumber,
            toyIds: finalWhereFilters?.productName,
            libraryIds: finalWhereFilters?.name,
            receivingLibraryIds: finalWhereFilters?.receivingLibName,
            orderTagIds:
              selectedTagIdsRef?.current?.length > 0
                ? selectedTagIdsRef.current
                : undefined,
          },
          sort: sortedInfo?.column
            ? {
                field: sortedInfo?.field,
                order: sortedInfo?.order === 'ascend' ? SORT?.ASC : SORT?.DESC,
              }
            : initialOrderSort,
        },
      });
    }
    setIsRequestLoadings(false);
  };

  const getFilterData = (confirm) => {
    setIsOrderLoading(true);
    returnOrdersAdmin({
      variables: {
        filter: {
          ...initialOrderFilter,
          search: orderSearchTerm,
          deliveryType: whereFilter?.deliveryType,
          dateRange: {
            from: whereFilter?.createdAt?.from?.$d,
            to: whereFilter?.createdAt?.to?.$d,
          },
          returnedOn: {
            from: whereFilter?.returnedOn?.from?.$d,
            to: whereFilter?.returnedOn?.to?.$d,
          },
          status:
            whereFilter?.status?.length > 0 ? whereFilter?.status : undefined,
          pincodeIds: whereFilter?.pincodes,
          deliveryPartnerIds: whereFilter?.deliveryPartnerName,
          returnOrderIds: whereFilter?.returnOrderNumber,
          toyIds: whereFilter?.productName,
          libraryIds: whereFilter?.name,
          receivingLibraryIds: whereFilter?.receivingLibName,
          orderTagIds:
            selectedTagIdsRef?.current?.length > 0
              ? selectedTagIdsRef.current
              : undefined,
        },
        sort: sortedInfo?.column
          ? {
              field: sortedInfo?.field,
              order: sortedInfo?.order === 'ascend' ? SORT?.ASC : SORT?.DESC,
            }
          : initialOrderSort,
      },
    });
    setFinalWhereFilters({ ...finalWhereFilters, ...whereFilter });
    setExportFilter({ ...exportFilter, ...finalWhereFilters, ...whereFilter });
    setFinalFilterTags(filterTags);
    setPaginationProp({ ...paginationProp, skip: 0, current: 1 });
    saveRetainedFilterState(TABLE_FILTER_KEYS.ALL_RETURN, {
      filters: { ...finalWhereFilters, ...whereFilter },
      paginationProp: { ...paginationProp, skip: 0, current: 1 },
    });
    if (confirm) {
      confirm();
    }
  };

  const handleReset = (clearFilters, dataIndex, confirm) => {
    const tagsCopy = {
      ...filterTags,
      [dataIndex]: [],
    };
    let whereFiltersCopy;
    if (dataIndex === 'deliveryType') {
      whereFiltersCopy = {
        ...whereFilter,
        [dataIndex]: null,
      };
    } else {
      whereFiltersCopy = {
        ...whereFilter,
        [dataIndex]: [],
      };
    }
    setFilterVisible(false);
    setFinalFilterTags({ ...filterTags, ...tagsCopy });
    setFinalWhereFilters({ ...finalWhereFilters, ...whereFiltersCopy });
    setExportFilter({
      ...exportFilter,
      ...finalWhereFilters,
      ...whereFiltersCopy,
    });
    setIsOrderLoading(true);
    returnOrdersAdmin({
      variables: {
        filter: {
          ...initialOrderFilter,
          search: orderSearchTerm,
          limit: paginationProp?.pageSize || LIMIT,
          deliveryType: whereFiltersCopy?.deliveryType,
          dateRange: {
            from: whereFiltersCopy?.createdAt?.from?.$d,
            to: whereFiltersCopy?.createdAt?.to?.$d,
          },
          returnedOn: {
            from: whereFiltersCopy?.returnedOn?.from?.$d,
            to: whereFiltersCopy?.returnedOn?.to?.$d,
          },
          status:
            whereFiltersCopy?.status?.length > 0
              ? whereFiltersCopy?.status
              : undefined,
          pincodeIds: whereFiltersCopy?.pincodes,
          deliveryPartnerIds: whereFiltersCopy?.deliveryPartnerName,
          returnOrderIds: whereFiltersCopy?.returnOrderNumber,
          toyIds: whereFiltersCopy?.productName,
          libraryIds: whereFiltersCopy?.name,
          receivingLibraryIds: whereFiltersCopy?.receivingLibName,
          orderTagIds:
            selectedTagIdsRef?.current?.length > 0
              ? selectedTagIdsRef.current
              : undefined,
        },
        sort: sortedInfo?.column
          ? {
              field: sortedInfo?.field,
              order: sortedInfo?.order === 'ascend' ? SORT?.ASC : SORT?.DESC,
            }
          : initialOrderSort,
      },
    });
    setPaginationProp({ ...paginationProp, skip: 0, current: 1 });
    saveRetainedFilterState(TABLE_FILTER_KEYS.ALL_RETURN, {
      filters: { ...finalWhereFilters, ...whereFiltersCopy },
      paginationProp: { ...paginationProp, skip: 0, current: 1 },
      filterTags: { ...filterTags, ...tagsCopy },
    });
    clearFilters();

    setFilterVisible(false);
    if (confirm) {
      confirm();
    }
  };

  useEffect(() => {
    if (filterVisible) {
      setFilterList([]);
      setFilterLoading(true);
      setIsEmptyFilterList(false);
      setFilterTags({ ...filterTags, ...finalFilterTags });
      saveRetainedFilterState(TABLE_FILTER_KEYS.ALL_RETURN, {
        filterTags: {
          ...filterTags,
          ...finalFilterTags,
        },
      });
      setWhereFilter({ ...whereFilter, ...finalWhereFilters });
      setFilterIsEnd(false);
      const optionsCopy = [];

      switch (filterIndex) {
        case 'returnOrderNumber':
          returnOrdersAdminSelect({
            variables: {
              filter: initialTableFilter,
              sort: initialTableSort,
            },
          });
          break;

        case 'deliveryPartnerName':
          users({
            variables: {
              filter: {
                ...initialTableFilter,
                roles: [USER_ROLES?.DELIVERY?.key],
              },
              sort: initialTableSort,
            },
          });
          break;

        case 'productName':
          toys({
            variables: {
              filter: {
                ...initialTableFilter,
              },
              sort: initialTableSort,
            },
          });
          break;

        case 'pincodes':
          pincodes({
            variables: {
              filter: {
                ...initialTableFilter,
              },
              sort: {
                field: 'pincode',
                order: 'ASC',
              },
            },
          });
          break;

        case 'deliveryType':
          forEach(DELIVERY_TYPE_OPTIONS, (item) => {
            optionsCopy?.push({ label: item?.label, key: item?.value });
          });
          setFilterList(optionsCopy);
          setFilterLoading(false);
          break;

        case 'status':
          forEach(RETURN_ORDER_ITEM_STATUS, (item) => {
            optionsCopy?.push({ label: item?.label, key: item?.value });
          });
          setFilterList(optionsCopy);
          setFilterLoading(false);
          break;

        case 'name':
          libraries({
            variables: {
              filter: initialTableFilter,
              sort: initialTableSort,
            },
          });
          break;

        case 'receivingLibName':
          receivingLibraries({
            variables: {
              filter: initialTableFilter,
              sort: initialTableSort,
            },
          });
          break;

        default:
          break;
      }
    }
    if (!filterVisible) {
      setFilterTags(finalFilterTags);
      saveRetainedFilterState(TABLE_FILTER_KEYS.ALL_RETURN, {
        filterTags: finalFilterTags,
      });
      setWhereFilter(finalWhereFilters);
      setFilterSearch('');
    }
  }, [filterVisible]);

  const onFilterScroll = (event, dataIndex) => {
    if (dataIndex === 'status') {
      return;
    }
    if (filterScrollDebounceJob) {
      filterScrollDebounceJob?.cancel();
      filterScrollDebounceJob = null;
    }
    if (
      !isPincodesLoading &&
      !isUsersLoading &&
      !isReturnOrdersAdminSelectLoading &&
      !isToysLoading &&
      !isLibrariesLoading &&
      !isReceivingLibrariesLoading &&
      !filterIsEnd
    ) {
      const target = event?.target;
      const currentLength = filterList?.length;
      if (
        target?.scrollTop + target?.offsetHeight >=
        target?.scrollHeight - 5
      ) {
        filterScrollDebounceJob = debounce(() => {
          setFilterLoading(true);
          switch (dataIndex) {
            case 'returnOrderNumber':
              returnOrdersAdminSelect({
                variables: {
                  filter: {
                    limit: LIMIT,
                    skip: currentLength,
                    search: filterSearch,
                  },
                  sort: initialTableSort,
                },
              });
              break;

            case 'deliveryPartnerName':
              users({
                variables: {
                  filter: {
                    limit: LIMIT,
                    skip: currentLength,
                    search: filterSearch,
                    roles: [USER_ROLES?.DELIVERY?.key],
                  },
                  sort: initialTableSort,
                },
              });
              break;

            case 'productName':
              toys({
                variables: {
                  filter: {
                    limit: LIMIT,
                    skip: currentLength,
                    search: filterSearch,
                  },
                  sort: initialTableSort,
                },
              });
              break;

            case 'pincodes':
              pincodes({
                variables: {
                  filter: {
                    limit: LIMIT,
                    skip: currentLength,
                    search: filterSearch,
                  },
                  sort: {
                    field: 'pincode',
                    order: 'ASC',
                  },
                },
              });
              break;

            case 'name':
              libraries({
                variables: {
                  filter: {
                    limit: LIMIT,
                    skip: currentLength,
                    search: filterSearch,
                  },
                  sort: initialTableSort,
                },
              });
              break;

            case 'receivingLibName':
              receivingLibraries({
                variables: {
                  filter: {
                    limit: LIMIT,
                    skip: currentLength,
                    search: filterSearch,
                  },
                  sort: initialTableSort,
                },
              });
              break;

            default:
              break;
          }
        }, 500);
        filterScrollDebounceJob();
      }
    }
  };

  const handleFilterSearch = (value, dataIndex) => {
    setFilterSearch(value);
    setFilterIsEnd(false);
    setFilterLoading(true);
    setFilterList([]);
    switch (dataIndex) {
      case 'returnOrderNumber':
        returnOrdersAdminSelect({
          variables: {
            filter: {
              ...initialTableFilter,
              limit: LIMIT,
              search: value,
            },
            sort: initialTableSort,
          },
        });
        break;

      case 'deliveryPartnerName':
        users({
          variables: {
            filter: {
              ...initialTableFilter,
              limit: LIMIT,
              search: value,
              roles: [USER_ROLES?.DELIVERY?.key],
            },
            sort: initialTableSort,
          },
        });
        break;

      case 'productName':
        toys({
          variables: {
            filter: {
              ...initialTableFilter,
              limit: LIMIT,
              search: value,
            },
            sort: initialTableSort,
          },
        });
        break;

      case 'pincodes':
        pincodes({
          variables: {
            filter: {
              ...initialTableFilter,
              limit: LIMIT,
              search: value,
            },
            sort: {
              field: 'pincode',
              order: 'ASC',
            },
          },
        });
        break;

      case 'name':
        libraries({
          variables: {
            filter: {
              ...initialTableFilter,
              limit: LIMIT,
              search: value,
            },
            sort: initialTableSort,
          },
        });
        break;

      case 'receivingLibName':
        receivingLibraries({
          variables: {
            filter: {
              ...initialTableFilter,
              limit: LIMIT,
              search: value,
            },
            sort: initialTableSort,
          },
        });
        break;

      default:
        break;
    }
  };

  const changeFilter = (newFilterObj, dataIndex) => {
    const {
      target: { value },
    } = newFilterObj;

    const filterTagsCopy = { ...filterTags };
    let newTagList;
    if (whereFilter?.[dataIndex]?.includes(value?.key)) {
      newTagList = {
        ...filterTagsCopy,
        [dataIndex]: filter(filterTagsCopy?.[dataIndex], (item) => {
          if (item?.label) {
            return item?.key !== value?.key;
          }
          return item !== value;
        }),
      };
    } else {
      newTagList = {
        ...filterTagsCopy,
        [dataIndex]: filterTagsCopy?.[dataIndex]
          ? [...filterTagsCopy?.[dataIndex], value]
          : [value],
      };
    }

    const updatedWhereFilter = {
      ...whereFilter,
      [dataIndex]: newTagList?.[dataIndex]?.map((item) => item?.key),
    };
    setWhereFilter(updatedWhereFilter);
    setFilterTags(newTagList);
    saveRetainedFilterState(TABLE_FILTER_KEYS.ALL_RETURN, {
      filterTags: newTagList,
    });
  };

  const handleDeleteFilter = (value, dataIndex) => {
    let newTagList;

    if (whereFilter?.[dataIndex]?.includes(value?.key)) {
      newTagList = {
        ...filterTags,
        [dataIndex]: filter(filterTags?.[dataIndex], (item) => {
          if (item?.key) {
            return item?.key !== value?.key;
          }
          return item !== value;
        }),
      };
    }

    const updatedWhereFilter = {
      ...whereFilter,
      [dataIndex]: newTagList?.[dataIndex]?.map((item) => item?.key),
    };
    setWhereFilter(updatedWhereFilter);
    setFilterTags(newTagList);
    saveRetainedFilterState(TABLE_FILTER_KEYS.ALL_RETURN, {
      filterTags: newTagList,
    });
  };

  const onRangePickerChange = (values, dataIndex) => {
    const rangeObj = {
      from: values[0]?.startOf('day'),
      to: values?.[1]?.endOf('day'),
    };

    const filtersCopy = {
      ...whereFilter,
      [dataIndex]: rangeObj,
    };
    if (!values?.length) {
      delete whereFilter?.[dataIndex];
    }
    setWhereFilter(filtersCopy);
  };

  const onRadioChange = (value, dataIndex) => {
    const filtersCopy = {
      ...whereFilter,
      [dataIndex]: value,
    };
    if (!value?.length) {
      delete whereFilter?.[dataIndex];
    }
    setWhereFilter(filtersCopy);
  };

  const filterPopup = (dataIndex, showSearch = true) => ({
    filterDropdown: ({ confirm, clearFilters }) => {
      if (dataIndex === 'createdAt' || dataIndex === 'returnedOn') {
        return (
          <div className="custom-filter-dropdown">
            <RangePicker
              allowClear={false}
              format={DATE_FORMATS?.REGULAR}
              onChange={(values) => onRangePickerChange(values, dataIndex)}
              value={
                whereFilter?.[dataIndex]?.from
                  ? [
                      whereFilter?.[dataIndex]?.from,
                      whereFilter?.[dataIndex]?.to,
                    ]
                  : null
              }
            />
            <Divider className="divider-filter" />
            <div className="d-flex justify-center">
              <Button
                size="small"
                className="reset-button"
                id="roles-filter-reset"
                onClick={() => handleReset(clearFilters, dataIndex, confirm)}
              >
                Reset
              </Button>
              <Button
                size="small"
                className="common-button ok-button"
                id="roles-filter-ok"
                type="primary"
                onClick={() => getFilterData(confirm, dataIndex)}
              >
                Ok
              </Button>
            </div>
          </div>
        );
      }

      if (dataIndex === 'deliveryType') {
        return (
          <div className="custom-filter-dropdown">
            <Group
              options={DELIVERY_TYPE_OPTIONS}
              value={whereFilter?.[dataIndex]}
              onChange={(e) => onRadioChange(e?.target?.value, dataIndex)}
            />
            <Divider className="divider-filter" />
            <div className="d-flex justify-center">
              <Button
                size="small"
                className="reset-button"
                id="roles-filter-reset"
                onClick={() => handleReset(clearFilters, dataIndex, confirm)}
              >
                Reset
              </Button>
              <Button
                size="small"
                className="common-button ok-button"
                id="roles-filter-ok"
                type="primary"
                onClick={() => getFilterData(confirm, dataIndex)}
              >
                Ok
              </Button>
            </div>
          </div>
        );
      }

      return (
        <div className="custom-filter-dropdown">
          <LoaderComponent
            spinning={filterLoading}
            setHeight={35}
            size="medium"
          >
            {showSearch && (
              <SearchComponent
                className="filter-search"
                id="search-container-id-roles"
                placeholder="Search..."
                name={dataIndex}
                query={filterSearch}
                setQuery={setFilterSearch}
                getData={(value) => handleFilterSearch(value, dataIndex)}
              />
            )}
            {filterTags?.[dataIndex]?.length > 0 && (
              <div className="filter-tags-wrapper">
                {map(filterTags?.[dataIndex], (item) => (
                  <Tag
                    key={item?.key}
                    closable
                    onClose={() => handleDeleteFilter(item, dataIndex)}
                    className="filter-tag"
                  >
                    <span>{item?.label}</span>
                  </Tag>
                ))}
              </div>
            )}
            <div
              className="filter-checkboxes"
              onScroll={(e) => onFilterScroll(e, dataIndex)}
            >
              {filterList?.length > 0
                ? map(filterList, (item) => (
                    <div className="single-checkbox-div" key={item?.key}>
                      <Checkbox
                        value={item}
                        checked={whereFilter?.[dataIndex]?.includes(item?.key)}
                        key={item?.key || item}
                        onChange={(e) => changeFilter(e, dataIndex)}
                        className="single-checkbox"
                      >
                        <span>{item?.label}</span>
                      </Checkbox>
                    </div>
                  ))
                : isEmptyFilterList && (
                    <Empty image={Empty?.PRESENTED_IMAGE_SIMPLE} />
                  )}
            </div>
          </LoaderComponent>
          <Divider className="divider-filter" />
          <div className="d-flex justify-center">
            <Button
              size="small"
              className="reset-button"
              id="roles-filter-reset"
              onClick={() => handleReset(clearFilters, dataIndex, confirm)}
            >
              Reset
            </Button>
            <Button
              size="small"
              className="common-button ok-button"
              id="roles-filter-ok"
              type="primary"
              onClick={() => getFilterData(confirm, dataIndex)}
            >
              Ok
            </Button>
          </div>
        </div>
      );
    },
    filterIcon: () =>
      finalWhereFilters?.[dataIndex]?.length > 0 ||
      !isEmpty(finalWhereFilters?.[dataIndex]) ||
      finalWhereFilters?.[dataIndex] === DELIVERY_TYPE?.PAID?.value ||
      finalWhereFilters?.[dataIndex] === DELIVERY_TYPE?.FREE?.value ? (
        <FilterFilled className="filter-icon filter-filled" />
      ) : (
        <FilterOutlined className="filter-icon" />
      ),
    onFilterDropdownOpenChange: (isVisible) => {
      setFilterIndex(dataIndex);
      setFilterVisible(isVisible);
    },
  });

  const columns = [
    {
      title: 'PRODUCT RETURN ID',
      dataIndex: 'returnOrderNumber',
      key: 'returnOrderNumber',
      align: 'left',
      ellipsis: true,
      fixed: 'left',
      className: 'max-width-column',
      width: 150,
      render: (_, record) => (
        <div className="d-flex align-center">
          <RenderCopyIcon
            copyText={record?.returnOrder?.returnOrderNumber}
            toolTipText="Copy Return ID"
          />
          {record?.returnOrder?.returnOrderNumber}
          {hasLargeToy(record) && <BigToyIcon />}
          {record?.returnOrder?.metadata?.autoReturnRequest && (
            <StatusFlag type={ORDER_TAG_TYPES.AUTO_RETURN} />
          )}
          <OrderDynamicTags tags={record?.returnOrder?.orderTags} />
        </div>
      ),
      ...filterPopup('returnOrderNumber'),
    },
    {
      title: 'PRODUCT NAME',
      fixed: 'left',
      dataIndex: 'productName',
      key: 'productName',
      ellipsis: true,
      align: 'left',
      width: 250,
      className: `max-width-column`,
      onCell: (record) =>
        !isSalesUser(currentUser) && {
          onClick: () =>
            isToyPermission &&
            record?.orderItem?.toy?.id &&
            openToyDrawer(record?.orderItem?.toy?.id),
          className: `${
            isToyPermission &&
            record?.orderItem?.toy?.id &&
            'pointer table-cell'
          }`,
        },
      render: (_, record) => {
        const toyData = record?.orderItem?.toy;
        return (
          <>
            <div className="table-data-with-id">{toyData?.name || '-'}</div>
            {toyData?.toyNumber && (
              <div className="font-size-12">({toyData?.toyNumber})</div>
            )}
          </>
        );
      },
      ...filterPopup('productName'),
    },
    {
      title: 'MAPPED UNIT',
      dataIndex: 'inventoryUnits',
      key: 'inventoryUnits',
      width: 200,
      align: 'left',
      className: 'max-width-column',
      onCell: () => ({
        onClick: (e) => e?.stopPropagation(),
      }),
      render: (_, record) => <MappedUnitsCell units={record?.inventoryUnits} />,
    },
    {
      title: 'ORDER ID',
      dataIndex: 'id',
      key: 'id',
      align: 'left',
      ellipsis: true,
      className: 'max-width-column',
      width: 150,
      render: (_, record) => (
        <div className="d-flex align-center">
          <RenderCopyIcon copyText={record?.order?.orderNumber} />
          {record?.order?.orderNumber || '-'}
        </div>
      ),
    },
    {
      title: 'ADLOGGS ORDER ID',
      dataIndex: 'partnerOrderId',
      key: 'partnerOrderId',
      align: 'left',
      ellipsis: true,
      className: 'max-width-column',
      width: 150,
      render: (_, record) => (
        <div className="d-flex align-center">
          <RenderCopyIcon
            copyText={record?.returnOrder?.partnerOrderId}
            toolTipText="Copy Adloggs Order ID"
          />
          {record?.returnOrder?.partnerOrderId || 'Not yet sent to Adloggs'}
        </div>
      ),
    },
    {
      title: 'DELIVERY TYPE',
      dataIndex: 'deliveryType',
      key: 'deliveryType',
      ellipsis: true,
      align: 'left',
      width: 150,
      className: 'max-width-column',
      render: (_, record) =>
        DELIVERY_TYPE?.[record?.order?.deliveryType]?.label,
      ...filterPopup('deliveryType'),
    },
    {
      title: 'USER NAME',
      dataIndex: 'userName',
      key: 'userName',
      ellipsis: true,
      align: 'left',
      width: 200,
      className: `max-width-column`,
      onCell: (record) => ({
        onClick: (e) =>
          isUserPermission &&
          record?.returnOrder?.user?.id &&
          handleOpenUserDrawer(e, record?.returnOrder?.user, dispatch),
        className: `${
          isUserPermission &&
          record?.returnOrder?.user?.id &&
          'pointer table-cell'
        }`,
      }),
      render: (_, record) => {
        const userData = record?.returnOrder?.user;
        return (
          <>
            {userData?.firstName || userData?.lastName ? (
              <div className="table-data-with-id">{`${
                userData?.firstName ? userData?.firstName : ''
              } ${userData?.lastName ? userData?.lastName : ''}`}</div>
            ) : (
              '-'
            )}
            {userData?.userNumber ? (
              <div className="font-size-12">({userData?.userNumber})</div>
            ) : (
              ''
            )}
          </>
        );
      },
    },
    {
      title: 'OWNER LIBRARY NAME',
      dataIndex: 'ownerLibraryName',
      key: 'ownerLibraryName',
      align: 'left',
      ellipsis: true,
      className: `max-width-column`,
      width: 300,
      render: (_, record) => {
        const ownerLib = record?.libraryInventory?.library;
        return ownerLib ? (
          <>
            <div className="table-data-with-id">{ownerLib?.name}</div>
            <div className="font-size-12">({ownerLib?.libraryNumber})</div>
          </>
        ) : (
          '-'
        );
      },
    },
    {
      title: 'SENDER LIBRARY NAME',
      dataIndex: 'name',
      key: 'name',
      align: 'left',
      ellipsis: true,
      className: `max-width-column`,
      width: 300,
      onCell: (record) =>
        !isSalesUser(currentUser) && {
          onClick: () =>
            isLibraryPermission &&
            record?.returnOrder?.library?.id &&
            history?.push(
              `${ROUTES?.MASTER_LISTS}${ROUTES?.LIBRARY}${ROUTES?.BASIC_DETAILS}/view/${record?.returnOrder?.library?.id}/${record?.returnOrder?.library?.libraryNumber}`,
            ),
          className: `${
            isLibraryPermission &&
            record?.returnOrder?.library?.id &&
            'pointer table-cell'
          }`,
        },
      render: (_, record) => {
        const ownerLib = record?.returnOrder?.library;
        return ownerLib ? (
          <>
            <div className="table-data-with-id">{ownerLib?.name}</div>
            <div className="font-size-12">({ownerLib?.libraryNumber})</div>
          </>
        ) : (
          '-'
        );
      },
      ...filterPopup('name'),
    },
    {
      title: 'RECEIVER LIBRARY NAME',
      dataIndex: 'receivingLibraryName',
      key: 'receivingLibraryName',
      align: 'left',
      ellipsis: true,
      className: `max-width-column`,
      width: 300,
      onCell: (record) =>
        !isSalesUser(currentUser) && {
          onClick: () =>
            isLibraryPermission &&
            record?.returnOrder?.receiverLibrary?.id &&
            history?.push(
              `${ROUTES?.MASTER_LISTS}${ROUTES?.LIBRARY}${ROUTES?.BASIC_DETAILS}/view/${record?.returnOrder?.receiverLibrary?.id}/${record?.returnOrder?.receiverLibrary?.receivingLibraryNumber}`,
            ),
          className: `${
            isLibraryPermission &&
            record?.returnOrder?.receiverLibrary?.id &&
            'pointer table-cell'
          }`,
        },
      render: (_, record) => {
        const receivingLib = record?.returnOrder?.receiverLibrary;
        return receivingLib ? (
          <>
            <div className="table-data-with-id">{receivingLib?.name}</div>
            <div className="font-size-12">({receivingLib?.libraryNumber})</div>
          </>
        ) : (
          '-'
        );
      },
      ...filterPopup('receivingLibName'),
    },
    {
      title: 'DELIVERY PARTNER NAME',
      dataIndex: 'deliveryPartnerName',
      key: 'deliveryPartnerName',
      ellipsis: true,
      align: 'left',
      width: 200,
      className: `max-width-column`,
      onCell: (record) =>
        !isSalesUser(currentUser) && {
          onClick: () =>
            isDeliveryPartnerPermission &&
            record?.returnOrder?.deliveryPartner?.id &&
            history?.push(
              `${ROUTES?.SYSTEM_USERS}${ROUTES?.DELIVERY_PARTNERS}/view/${record?.returnOrder?.deliveryPartner?.id}`,
            ),
          className: `${
            isDeliveryPartnerPermission &&
            record?.returnOrder?.deliveryPartner?.id &&
            'pointer table-cell'
          }`,
        },
      render: (_, record) => {
        const deliveryPartnerData = record?.returnOrder?.deliveryPartner;
        const deliveryStaffDetails =
          record?.returnOrder?.metadata?.deliveryStaffDetails;

        const partnerData = deliveryPartnerData || deliveryStaffDetails;

        return (
          <>
            {partnerData?.firstName ||
            partnerData?.lastName ||
            partnerData?.name ? (
              <div className="table-data-with-id">{`${
                partnerData?.firstName || partnerData?.name || ''
              } ${partnerData?.lastName || ''}`}</div>
            ) : (
              '-'
            )}
            {partnerData?.userNumber || partnerData?.phone ? (
              <div className="font-size-12">
                ({partnerData?.userNumber || partnerData?.phone})
              </div>
            ) : (
              ''
            )}
          </>
        );
      },
      ...filterPopup('deliveryPartnerName'),
    },
    {
      title: 'PINCODE',
      dataIndex: 'pincode',
      key: 'pincode',
      ellipsis: true,
      align: 'left',
      width: 150,
      className: 'max-width-column',
      render: (_, record) => record?.returnOrder?.user?.pincode?.pincode || '-',
      ...filterPopup('pincodes'),
    },
    {
      title: 'PLACED ON',
      dataIndex: 'placedOn',
      key: 'placedOn',
      ellipsis: true,
      align: 'left',
      width: 200,
      className: 'max-width-column',
      render: (_, record) =>
        formatDate(record?.createdAt, DATE_FORMATS?.WITH_TIME),
      ...filterPopup('createdAt'),
    },
    {
      title: 'RETURNED ON',
      dataIndex: 'deliveredOn',
      key: 'deliveredOn',
      ellipsis: true,
      align: 'left',
      width: 200,
      className: 'max-width-column',
      render: (_, record) =>
        formatDate(record?.returnedOn, DATE_FORMATS?.REGULAR) || '-',
      ...filterPopup('returnedOn'),
    },
    {
      title: 'PICKED UP ATTACHMENT',
      dataIndex: 'pickedUpAttachments',
      key: 'pickedUpAttachments',
      ellipsis: true,
      width: 200,
      align: 'left',
      className: 'max-width-column',
      render: (_, record) => {
        const pickedUpAttachments = record?.deliveryAttachments?.filter(
          (attachment) =>
            [RETURN_ORDER_ITEM_STATUS?.PICKED_UP?.value, null]?.includes(
              attachment?.deliveryAttachmentsType,
            ),
        );

        const hasAttachments = pickedUpAttachments?.length > 0;
        const additionalCount = pickedUpAttachments?.length - 1;

        return (
          <span>
            {hasAttachments ? (
              <Image
                preview={{ visible: false }}
                width={20}
                height={20}
                src={getAttachmentSource(pickedUpAttachments?.[0])}
                onClick={(e) => {
                  e?.stopPropagation();
                  setVisible(true);
                  setToyImages(pickedUpAttachments);
                }}
                className="pointer"
              />
            ) : (
              <span>No Images</span>
            )}
            {additionalCount > 0 && ` + ${additionalCount}`}
          </span>
        );
      },
    },
    {
      title: 'RETURNED ATTACHMENTS',
      dataIndex: 'returnedAttachments',
      key: 'returnedAttachments',
      ellipsis: true,
      width: 200,
      align: 'left',
      className: 'max-width-column',
      render: (_, record) => {
        const returnedAttachments = record?.deliveryAttachments?.filter(
          (attachment) =>
            attachment?.deliveryAttachmentsType ===
            RETURN_ORDER_ITEM_STATUS?.RETURNED?.value,
        );

        const hasAttachments = returnedAttachments?.length > 0;
        const additionalCount = returnedAttachments?.length - 1;

        return (
          <span>
            {hasAttachments ? (
              <Image
                preview={{ visible: false }}
                width={20}
                height={20}
                src={getAttachmentSource(returnedAttachments?.[0])}
                onClick={(e) => {
                  e?.stopPropagation();
                  setVisible(true);
                  setToyImages(returnedAttachments);
                }}
                className="pointer"
              />
            ) : (
              <span>No Images</span>
            )}
            {additionalCount > 0 && ` + ${additionalCount}`}
          </span>
        );
      },
    },
    {
      title: 'STATUS',
      dataIndex: 'status',
      key: 'status',
      ellipsis: true,
      width: 150,
      align: 'left',
      className: 'max-width-column',
      render: (_, record) => RETURN_ORDER_ITEM_STATUS?.[record?.status]?.label,
      ...filterPopup('status', false),
    },
    {
      title: 'NOTE',
      dataIndex: 'note',
      key: 'note',
      ellipsis: true,
      width: 150,
      align: 'left',
      className: 'max-width-column',
      render: (_, record) => (
        <div className="action-button" onClick={(e) => e?.stopPropagation()}>
          {record?.status === RETURN_ORDER_ITEM_STATUS?.NOT_PICKED_UP?.value &&
          record?.returnOrder?.metadata?.notPickedUpReason ? (
            <Tooltip title="View reason" placement="top" zIndex={4}>
              <CommentIcon
                className="mr-16 pointer svg-icon"
                onClick={() => {
                  const partnerData =
                    record?.returnOrder?.deliveryPartner ||
                    record?.returnOrder?.metadata?.deliveryStaffDetails;
                  const riderName = partnerData
                    ? `${partnerData?.firstName || partnerData?.name || ''} ${
                        partnerData?.lastName || ''
                      }`.trim()
                    : '';
                  setNotPickedUpReason(
                    record?.returnOrder?.metadata?.notPickedUpReason,
                  );
                  setNotPickedUpRiderName(riderName);
                  setIsNotPickedUpReasonModalOpen(true);
                }}
              />
            </Tooltip>
          ) : (
            <span className="mr-24">-</span>
          )}
        </div>
      ),
    },
    {
      title: 'SKIP CHECKLIST',
      dataIndex: 'skipChecklist',
      key: 'skipChecklist',
      width: 150,
      align: 'left',
      onCell: () => ({
        onClick: (e) => e?.stopPropagation(),
      }),
      render: (_, record) =>
        hasUpdatePermission ? (
          <SkipChecklistAction
            returnOrderId={record?.returnOrder?.id}
            status={record?.status}
            value={getSkipChecklistValue(record?.returnOrder)}
          />
        ) : (
          '-'
        ),
    },
    {
      title: 'ACTIONS',
      dataIndex: 'actions',
      key: 'actions',
      ellipsis: true,
      width: 300,
      render: (_, record) => (
        <div onClick={(e) => e?.stopPropagation()}>
          <div className="action-button">
            <div className="mr-16">
              <Button
                type="primary"
                size="small"
                className="table-action-primary-btn"
                onClick={() => {
                  setOrder(record);
                  setIsContentMasterModalOpen(true);
                }}
              >
                View Content Logs
              </Button>
            </div>
            {hasUpdatePermission && (
              <Button
                type="primary"
                size="small"
                className="table-action-primary-btn"
                onClick={() => {
                  setIsRequestPrompts(true);
                  setOrder(record);
                }}
                disabled={
                  record?.status ===
                  RETURN_ORDER_ITEM_STATUS?.RETURN_CONFIRMED?.value
                }
              >
                Cancel Request
              </Button>
            )}
            <Tooltip title="Status Logs" placement="top" zIndex={4}>
              <InfoIcon
                onClick={() => {
                  setOrder(record);
                  setIsOrderStatusModalOpen(true);
                }}
                className="ml-16 pointer svg-icon"
              />
            </Tooltip>
            {record?.returnOrder?.metadata?.adloggsOrderTrackUrl && (
              <Tooltip title="Track Order" placement="top" zIndex={4}>
                <TruckIcon
                  className="ml-16 pointer svg-icon"
                  onClick={() => {
                    setTrackingUrl(
                      record?.returnOrder?.metadata?.adloggsOrderTrackUrl,
                    );
                    setIsTrackingModalOpen(true);
                  }}
                />
              </Tooltip>
            )}
          </div>
        </div>
      ),
    },
    {
      title: 'CLUB ORDER NAME',
      dataIndex: 'clubOrderName',
      key: 'clubOrderName',
      align: 'left',
      ellipsis: true,
      className: 'max-width-column',
      width: 260,
      render: (_, record) =>
        record?.returnOrder?.metadata?.clubOrderName || '-',
    },
  ]?.filter((item) => {
    if (item?.dataIndex === 'actions' && !hasUpdatePermission) {
      return item?.hidden;
    }
    return !item?.hidden;
  });

  const expandedRowRender = (data) => {
    const nestedData = [
      {
        id: data?.id,
        productName: data?.orderItem?.toy?.name,
        ageGroups: data?.orderItem?.toy?.ageGroups,
        toyCondition: data?.toyCondition,
        images: data?.images,
        productRate: data?.productRate,
        toyId: data?.orderItem?.toy?.id,
        toyNumber: data?.orderItem?.toy?.toyNumber,
        brand: data?.orderItem?.toy?.brand?.name,
        videoUrl: data?.videoUrl,
        returnOrderNumber: data?.returnOrder?.returnOrderNumber,
        productImages: data?.orderItem?.toy?.images,
        packagingMaterial: data?.orderItem?.toy?.bag,
        libraryInventoryId: data?.libraryInventory?.id,
      },
    ];

    const nestedColumns = [
      {
        title: 'PRODUCT NAME',
        fixed: 'left',
        dataIndex: 'productName',
        key: 'productName',
        ellipsis: true,
        align: 'left',
        width: 250,
        className: `max-width-column`,
        onCell: (record) =>
          !isSalesUser(currentUser) && {
            onClick: () =>
              isToyPermission && record?.toyId && openToyDrawer(record?.toyId),
            className: `${
              isToyPermission && record?.toyId && 'pointer table-cell'
            }`,
          },
        render: (_, record) => (
          <>
            <div className="table-data-with-id">
              {record?.productName || '-'}
            </div>
            {record?.toyNumber && (
              <div className="font-size-12">({record?.toyNumber})</div>
            )}
          </>
        ),
      },
      {
        title: 'IMAGES',
        dataIndex: 'productImages',
        key: 'productImages',
        ellipsis: true,
        width: 100,
        align: 'left',
        className: 'max-width-column',
        render: (_, record) => {
          const images = record?.productImages;
          return (
            <span>
              {images?.length > 0 ? (
                <>
                  <Image
                    preview={{
                      visible: false,
                    }}
                    width={20}
                    height={20}
                    src={images?.[0]?.url}
                    onClick={(e) => {
                      e?.stopPropagation();
                      setVisible(true);
                      setToyImages(images);
                    }}
                    className="pointer"
                  />
                </>
              ) : (
                <span>No Images</span>
              )}
              {images?.length > 1 ? ` + ${images?.length - 1}` : ''}
            </span>
          );
        },
      },
      {
        title: 'BRAND',
        dataIndex: 'brand',
        key: 'brand',
        align: 'left',
        width: 300,
        className: 'max-width-column',
        render: (_, record) => record?.brand || '-',
      },
      {
        title: 'PACKAGING MATERIAL',
        dataIndex: 'packagingMaterial',
        key: 'packagingMaterial',
        ellipsis: true,
        width: 250,
        align: 'left',
        className: 'max-width-column',
        render: (_, record) => (
          <>
            {record?.packagingMaterial ? (
              <div>
                <span className="mr-8">
                  {record?.packagingMaterial?.name} (
                  {record?.packagingMaterial?.size})
                </span>
                <Image
                  preview={{ visible: false }}
                  width={22}
                  src={record?.packagingMaterial?.image}
                  onClick={(e) => {
                    e?.stopPropagation();
                    setPreviewVisible(true);
                    setToyPreviewImage(record?.packagingMaterial?.image);
                  }}
                  className="pointer"
                />
              </div>
            ) : (
              '-'
            )}
          </>
        ),
      },
      {
        title: 'AGE GROUPS',
        dataIndex: 'ageGroups',
        key: 'ageGroups',
        align: 'left',
        width: 300,
        className: 'max-width-column',
        render: (_, record) =>
          record?.ageGroups?.map((ageGroup) =>
            ageGroup?.minAge > 18 ? (
              <Tag key={ageGroup?.id}>
                {Math.floor(ageGroup?.minAge / 12)} -{' '}
                {Math.floor(ageGroup?.maxAge / 12)} Years
              </Tag>
            ) : (
              <Tag key={ageGroup?.id}>
                {ageGroup?.minAge} - {ageGroup?.maxAge} Months
              </Tag>
            ),
          ),
      },
      {
        title: 'RETURN TOY IMAGES',
        dataIndex: 'image',
        key: 'image',
        ellipsis: true,
        width: 100,
        align: 'left',
        className: 'max-width-column',
        render: (_, record) => (
          <span>
            {record?.images?.length > 0 ? (
              <>
                <Image
                  preview={{
                    visible: false,
                  }}
                  width={20}
                  height={20}
                  src={record?.images?.[0]?.url}
                  onClick={(e) => {
                    e?.stopPropagation();
                    setVisible(true);
                    setToyImages(record?.images);
                  }}
                  className="pointer"
                />
              </>
            ) : (
              <span>No Images</span>
            )}
            {record?.images?.length > 1
              ? ` + ${record?.images?.length - 1}`
              : ''}
          </span>
        ),
      },
      {
        title: 'VIDEO',
        dataIndex: 'video',
        key: 'video',
        ellipsis: true,
        width: 100,
        align: 'left',
        className: 'max-width-column',
        render: (_, record) => (
          <span>
            {record?.videoUrl ? (
              <Tooltip title="Play" placement="top" zIndex={4}>
                <PlayIcon
                  onClick={() => {
                    setOrderItem(record);
                    setIsVideoModalOpen(true);
                  }}
                  className="mr-16 pointer svg-icon"
                />
              </Tooltip>
            ) : (
              '-'
            )}
          </span>
        ),
      },
      {
        title: 'PRODUCT RATING',
        dataIndex: 'productRate',
        key: 'productRate',
        ellipsis: true,
        align: 'left',
        width: 250,
        className: 'max-width-column',
        render: (_, record) => (
          <div className="action-button">
            {record?.productRate === PRODUCT_RATE?.LIKE ? (
              <Tooltip title="Rated" placement="top">
                <LikeRatingIcon className="mr-16 svg-icon" />
              </Tooltip>
            ) : (
              <Tooltip title="Unrated" placement="top">
                <DislikeRatingIcon className="mr-16 svg-icon" />
              </Tooltip>
            )}
          </div>
        ),
      },
      {
        title: 'ORDER FULFILMENT',
        dataIndex: 'orderFulfilment',
        key: 'orderFulfilment',
        align: 'left',
        width: 200,
        render: (_, record) => (
          <Button
            type="primary"
            size="small"
            onClick={(e) => {
              e.stopPropagation();
              setSelectedPossibilityItem(record);
              setPossibilityDrawerVisible(true);
            }}
          >
            View
          </Button>
        ),
      },
    ];

    return (
      <CommonTable
        columns={nestedColumns}
        data={nestedData || []}
        paginationConfig={false}
        rowKey={(record) => record?.id}
        className="nested-table"
      />
    );
  };

  const locale = {
    emptyText: isEmptyOrderList ? '' : <span />,
  };

  const rowSelection = {
    selectedRowKeys: selectedReturnOrders,
    onChange: (selectedRowKeys) => setSelectedReturnOrders(selectedRowKeys),
    fixed: true,
    preserveSelectedRowKeys: true,
  };

  const selectedReturnsUniqueTags = useMemo(() => {
    const selectedReturns = (selectedReturnOrders || [])
      .map((id) => (orderList || []).find((r) => r?.returnOrder?.id === id))
      .filter(Boolean);

    return Array.from(
      new Map(
        selectedReturns
          ?.flatMap((r) => r?.returnOrder?.orderTags || [])
          ?.filter((t) => t?.id)
          ?.map((t) => [t?.id, t]),
      ).values(),
    );
  }, [orderList, selectedReturnOrders]);

  const handleSelectOrders = (key) => {
    setSelectedReturnOrders((prev) => {
      if (prev?.includes(key)) {
        return prev?.filter((item) => item !== key);
      }
      return [...prev, key];
    });
  };

  const findSelectableOrders = () => orderList || [];

  const handleSelectAllMobile = (checked) => {
    if (checked) {
      setSelectedReturnOrders((prev) => {
        const newIds = (orderList || [])
          ?.map((data) => data?.returnOrder?.id || data?.id)
          ?.filter(Boolean);
        return Array.from(new Set([...prev, ...newIds]));
      });
    } else {
      setSelectedReturnOrders([]);
    }
  };

  const handleCancel = () => {
    setIsContentMasterModalOpen(false);
    setOrder({});
  };

  return (
    <>
      <ContentMasterModal
        isModalOpen={isContentMasterModalOpen}
        contentHistory={order?.contentHistory}
        handleCancel={handleCancel}
        isReturn
      />
      <ReturnItemStatusModal
        title="Status Logs"
        isModalOpen={isOrderStatusModalOpen}
        setIsModalOpen={setIsOrderStatusModalOpen}
        statusHistories={order?.returnOrder?.statusHistory}
      />
      <Modal
        title="Caution"
        okText="Yes"
        cancelText="No"
        open={isRequestPrompts}
        onOk={handleReturnRequest}
        onCancel={() => setIsRequestPrompts(false)}
        okButtonProps={{ loading: isRequestLoadings }}
      >
        Are you sure you want to
        <strong> Cancel return request </strong>for this?
      </Modal>
      <CommonPreviewTable
        visible={visible}
        setVisible={setVisible}
        images={toyImages}
        setImages={setToyImages}
      />
      <CommonPreview
        visible={previewVisible}
        setVisible={setPreviewVisible}
        image={toyPreviewImage}
        setImage={setToyPreviewImage}
      />
      <ToyVideoModal
        title={`Video - ${orderItem?.returnOrderNumber}`}
        isModalOpen={isVideoModalOpen}
        setIsModalOpen={setIsVideoModalOpen}
        videoUrl={orderItem?.videoUrl}
      />
      <FulfilmentPossibilityDrawer
        visible={possibilityDrawerVisible}
        onClose={() => setPossibilityDrawerVisible(false)}
        libraryInventoryId={selectedPossibilityItem?.libraryInventoryId}
        returnOrderItemId={selectedPossibilityItem?.id}
        isReturnsOrderView
        isDesktop={isDesktop}
      />
      <TrackOrderIframeModal
        isTrackingModalOpen={isTrackingModalOpen}
        setIsTrackingModalOpen={setIsTrackingModalOpen}
        trackingUrl={trackingUrl}
      />
      <ModalComponent
        open={isNotPickedUpReasonModalOpen}
        onCancel={() => setIsNotPickedUpReasonModalOpen(false)}
        footer={null}
      >
        <div className="mb-8">
          <b className="font-size-16">
            Not Picked Up{' '}
            {notPickedUpRiderName ? `by ${notPickedUpRiderName}` : 'Reason'}
          </b>
        </div>
        <div className="font-size-16">Reason: {notPickedUpReason || '-'}</div>
      </ModalComponent>
      <div className="d-flex justify-end align-center mb-16 flex-wrap">
        <BulkActionButton
          selectedItemIds={selectedReturnOrders}
          actions={ORDER_TAG_BULK_ACTIONS}
          scope="SYSTEM_USERS_END_USERS"
          supportsNestedSubmit
          selectedTagsForRemove={selectedReturnsUniqueTags}
          drawerTitle="Return Bulk Actions"
          className="mr-8"
          onSuccess={() => handleSearch(query)}
          onClearSelection={() => setSelectedReturnOrders([])}
          tagConfigSubtype="ORDERS"
          useOrderTagsApi
          orderTagTargetField="returnOrders"
        />

        <OrderTagsFilter
          value={selectedTagIds}
          onChange={handleTagFilterChange}
          placeholder="Filter by Tags"
          className="ml-8"
        />
        <SearchComponent
          className="search-box ml-16"
          query={query}
          setQuery={setQuery}
          getData={handleSearch}
          tableFilterKey={TABLE_FILTER_KEYS.ALL_RETURN}
        />

        {!isDesktop && (
          <div className="d-flex justify-end align-center">
            <Checkbox
              indeterminate={
                selectedReturnOrders?.length < findSelectableOrders()?.length &&
                selectedReturnOrders?.length > 0
              }
              checked={
                selectedReturnOrders?.length > 0 &&
                selectedReturnOrders?.length ===
                  findSelectableOrders()?.length &&
                !isOrderLoading &&
                !isFetchMoreOrderLoading
              }
              onChange={(e) => {
                handleSelectAllMobile(e?.target?.checked);
              }}
              className="ml-16"
            >
              Select all
            </Checkbox>
            <Badge dot={hasNonEmptyValueObj(finalWhereFilters)} size="small">
              <FilterIcon
                className="mobile-svg-icon ml-16"
                onClick={() => setIsAllFilterModalOpen(true)}
              />
            </Badge>
          </div>
        )}
      </div>

      {isDesktop ? (
        <CommonTable
          locale={locale}
          columns={columns}
          data={orderList || []}
          loading={isOrderLoading}
          rowSelection={rowSelection}
          onChange={handleTableChange}
          paginationConfig={paginationProp}
          rowKey={(record) => record?.returnOrder?.id || record?.id}
          onRow={() => ({
            style: { cursor: 'pointer' },
          })}
          expandable={{
            expandRowByClick: true,
            expandedRowRender: (record) => expandedRowRender(record),
          }}
        />
      ) : (
        <div className="mobile-container-tab no-scroll-bar">
          <AllFilterReturnOrderModal
            onFinish={handleFilter}
            isModalOpen={isAllFilterModalOpen}
            setIsModalOpen={setIsAllFilterModalOpen}
            finalWhereFilters={finalWhereFilters}
            setFinalWhereFilters={setFinalWhereFilters}
            tableFilterKey={TABLE_FILTER_KEYS.ALL_RETURN}
          />
          <AllReturnOrderItemModal
            order={order}
            setOrder={setOrder}
            isModalOpen={isAllReturnOrderItemModalOpen}
            setIsModalOpen={setIsAllReturnOrderItemModalOpen}
            setVisible={setVisible}
            setToyImages={setToyImages}
          />
          <AllReturnOrderList
            orderList={orderList}
            infiniteScrollRef={infiniteScrollRef}
            isFetchMoreOrderLoading={isFetchMoreOrderLoading}
            isEmptyOrderList={isEmptyOrderList}
            isOrderLoading={isOrderLoading}
            setOrder={setOrder}
            setIsContentMasterModalOpen={setIsContentMasterModalOpen}
            setIsAllReturnOrderItemModalOpen={setIsAllReturnOrderItemModalOpen}
            setVisible={setVisible}
            setToyImages={setToyImages}
            setIsRequestPrompts={setIsRequestPrompts}
            setIsOrderStatusModalOpen={setIsOrderStatusModalOpen}
            isAdmin
            handleSelectOrders={handleSelectOrders}
            selectedOrders={selectedReturnOrders}
          />
        </div>
      )}
    </>
  );
};

export default AllReturnTable;
